export interface IPaginationEvent {
    sortField: string;
    sortDirection: any;
    pageIndex: number;
    pageSize: number;
}

export const TABLE_CONSTANTS = {
    START_PAGE: 0,
    PAGE_SIZE: 10,
    PAGE_SIZE_OPTIONS: [10, 25, 50],
    START_SORT: 'asc'
};

export interface ITableButtonEvent<T> {
    key: string;
    detailObject?: T;
}